// A little buzz on a phone that offers one; silently nothing anywhere else.
export type HapticKind = 'light' | 'medium' | 'success' | 'error';

const PATTERN: Record<HapticKind, number | number[]> = { light: 8, medium: 16, success: [10, 40, 10], error: [30, 40, 30] };

export function haptic(kind: HapticKind): void {
  // a browser only buzzes after the page has been touched, and complains otherwise
  const active = (navigator as Navigator & { userActivation?: { hasBeenActive: boolean } }).userActivation?.hasBeenActive ?? true;
  // and only a touch device has anything to buzz: a desktop browser logs a complaint instead
  if (!active || navigator.maxTouchPoints === 0) return;
  try { navigator.vibrate?.(PATTERN[kind]); } catch { /* not offered */ }
}
